// skills/farming/index.js
// Farming skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import {
    renderFarmingUI,
    updateFarmingUI,
    initFarmingUI,
    toggleRaking,
    toggleRakingMinimized,
    toggleToolbar,
    upgradeTool,
    switchTab,
    openPlantModal,
    closePlantModal,
    switchPlantModalTab,
    plantInPlot,
    harvestPlot,
    harvestAll,
    removePlant,
    toggleAutoHarvest,
    toggleAutoPlant,
    setAutoPlantMode,
    setAutoPlantSeed,
    toggleSeedPicker,
    setAutoHarvestDestination,
    openPlantAllModal,
    closePlantAllModal,
    plantAllCrops
} from './farmingUI.js';

/**
 * Farming skill configuration
 * Passive plot-based growth system with active raking for seeds
 */
const farmingConfig = {
    id: 'farming',
    name: 'Farming',
    icon: '🌾',
    iconImage: 'assets/icons/skill_icons/farming.png',
    description: 'Grow crops and trees in real-time plots',

    tabs: [
        { id: 'plots', name: 'Plots', default: true },
        { id: 'crops', name: 'Crops' },
        { id: 'herbs', name: 'Herbs' },
        { id: 'trees', name: 'Trees' },
    ],

    render(params = {}) {
        renderFarmingUI(params);
    },

    update() {
        updateFarmingUI();
    },

    init() {
        initFarmingUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('farming', farmingConfig);

if (typeof window !== 'undefined') {
    window.farmingUI = {
        toggleRaking,
        toggleRakingMinimized,
        toggleToolbar,
        upgradeTool,
        switchTab,
        openPlantModal,
        closePlantModal,
        switchPlantModalTab,
        plantInPlot,
        harvestPlot,
        harvestAll,
        removePlant,
        toggleAutoHarvest,
        toggleAutoPlant,
        setAutoPlantMode,
        setAutoPlantSeed,
        toggleSeedPicker,
        setAutoHarvestDestination,
        openPlantAllModal,
        closePlantAllModal,
        plantAllCrops
    };
}

export default farmingConfig;
